'use client';

// The Gear rail's product image tile — a square on a literal white
// background in both themes (docs/plans/2026-09-15-gear-v2-brief.md §3:
// "product photos sit on white"). #ffffff is intentional here: it is a
// product-photography convention, not a themed surface, so it does not go
// through an `--ed-*`/`--rt-*` token. The thumbnail fills ~80% of the tile
// and is always the largest element on the card/product view that hosts it.

import type { Product } from '@roomtreatment/av-catalog';
import GearProductThumb from './GearProductThumb';

/** The product-photo ground, for every surface that shows a product render
 *  (the Gear rail, and the homepage's captured renders). Exported so the
 *  literal lives in this one allowlisted file. */
export const PRODUCT_TILE_BG = '#ffffff';

export default function GearImageTile({ product, className }: { product: Product; className?: string }) {
  return (
    <div
      className={`relative flex aspect-square w-full shrink-0 items-center justify-center overflow-hidden rounded-lg ${className ?? ''}`}
      style={{ background: PRODUCT_TILE_BG }}
    >
      <GearProductThumb product={product} className="h-[80%] w-[80%] object-contain" />
    </div>
  );
}
